import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { MailWarning } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LABELS = { backup: "Backup email", test_email: "Test email" };

export const EmailHealthBanner = () => {
  const [issues, setIssues] = useState([]);

  useEffect(() => {
    axios.get(`${API}/health/email`).then((r) => setIssues(r.data.issues || [])).catch(() => {});
  }, []);

  if (issues.length === 0) return null;

  return (
    <Alert className="mb-6 bg-red-50 border-red-200" data-testid="email-health-banner">
      <MailWarning className="h-5 w-5 text-red-600" />
      <AlertDescription className="ml-2">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="space-y-2">
            <p className="font-semibold text-red-900">Email delivery is failing — check your SMTP settings</p>
            {issues.map((issue) => (
              <div key={issue.type} className="text-sm text-red-800" data-testid={`email-health-issue-${issue.type}`}>
                <span className="font-medium">{LABELS[issue.type]}</span> to {issue.recipient} failed
                {issue.at ? ` on ${new Date(issue.at).toLocaleString()}` : ""}.
                {issue.error && <p className="text-xs text-red-700 mt-0.5 break-words">{issue.error}</p>}
              </div>
            ))}
          </div>
          <Button asChild size="sm" variant="outline" className="border-red-300 text-red-700 hover:bg-red-100" data-testid="email-health-fix-link">
            <Link to="/settings">Open Email Settings</Link>
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};
